// InfoButton: the ⓘ beside a section's name that says what it is and how it
// plays, when asked (pick'em, B-484).
//
// A POPOVER UNDER THE ICON from a tablet up, a sheet from the bottom on a
// phone, as the About button is (B-276): a few lines of how-to in a popover a
// thumb has to aim at reads worse than a sheet it can pull away. Words only,
// read and closed; anything a person acts on belongs on the screen.

import { useState, type ReactNode } from 'react';
import { useTier } from '../shell/useTier';
import { Popover, Sheet } from './overlays';
import { Heading, IconButton, Stack } from './ui';

export function InfoButton({
  label,
  title,
  children,
}: {
  /** What the button does, for a screen reader and the hint: "How pick'em works". */
  label: string;
  /** The heading over the words. */
  title: string;
  children: ReactNode;
}) {
  const phone = useTier() === 'phone';
  const [open, setOpen] = useState(false);
  if (!phone)
    return (
      <Popover width={340} button={{ icon: 'info', label, variant: 'quiet' }}>
        <div className="fsp-info">
          <Stack gap={2}>
            <Heading>{title}</Heading>
            {children}
          </Stack>
        </div>
      </Popover>
    );
  return (
    <>
      <IconButton icon="info" label={label} variant="quiet" onClick={() => setOpen(true)} />
      {/* Peeking, not full height: a few lines in a sheet over most of the
          screen read as a page with nothing on it. */}
      <Sheet opened={open} onClose={() => setOpen(false)} title={title} peek>
        <div className="fsp-info">{children}</div>
      </Sheet>
    </>
  );
}
